// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { CSSProperties } from 'react';

const colors = {
  arrowGray: '#999999',
  stepText: '#FFFFFF',
  green: '#00D2AA',
  textPrimary: '#1C1917',
  textSecondary: '#78716C'
};

export const root: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  margin: '0 auto 32px',
  padding: '0 20px',
  boxSizing: 'border-box'
};

export const logoWrap: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 8
};

export const logoImage: CSSProperties = {
  display: 'block',
  height: 40,
  width: 'auto',
  objectFit: 'contain'
};

export const arrowDown: CSSProperties = {
  width: 0,
  height: 0,
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderTop: `14px solid ${colors.green}`,
  margin: '0 auto 24px'
};

export const mainTitle: CSSProperties = {
  fontFamily: 'G42 Sans Black Regular',
  fontWeight: 400,
  textTransform: 'uppercase',
  color: '#333333',
  margin: 0,
  lineHeight: '30px',
  fontSize: 30
};

export const subtitle: CSSProperties = {
  fontFamily: 'G42 Sans, sans-serif',
  fontSize: 20,
  fontWeight: 300,
  color: 'rgba(51, 51, 51, 0.5)',
  textAlign: 'center',
  margin: '10px 0 20px 0',
  lineHeight: 1.5
};

export const stepsRow: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: 0,
  width: '100%',
  maxWidth: '100%'
};

export const flowStep: CSSProperties = {
  borderRadius: 12,
  padding: '20px 16px',
  minWidth: 130,
  maxWidth: 223,
  // Default width; CSS media query in index.css narrows this to 200px
  // only for 1920x1080 @ 50% zoom.
  width: 223,
  height: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  lineHeight: 1.3,
  boxSizing: 'border-box'
};

export const stepText: CSSProperties = {
  color: colors.stepText,
  fontSize: 14,
  fontWeight: 300,
  textAlign: 'center',
  lineHeight: 1.3,
  fontFamily: 'G42 Sans, sans-serif',
  letterSpacing: 0.5,
  margin: 0
};

export const triangle: CSSProperties = {
  width: 0,
  height: 0,
  borderTop: '12px solid transparent',
  borderBottom: '12px solid transparent',
  borderLeft: '16px solid #999999',
  flexShrink: 0,
  marginLeft: 22,
  marginRight: 22,
  alignSelf: 'center',
  opacity: 0.3
};

export const arrowDownBottom: CSSProperties = {
  width: 0,
  height: 0,
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderTop: `14px solid ${colors.green}`,
  margin: '28px auto 0'
};
